import { TAnswerValue } from './types';

export const trackingValue = (
  questionId: string,
  value: TAnswerValue,
): string | undefined => {
  if (value === undefined) return undefined;

  if (questionId === 'schufaScore' && typeof value === 'number') {
    if (value < 5000) return '<5000';
    if (value < 6800) return '5000-6799';
    if (value < 8000) return '6800-7999';
    if (value < 9050) return '8000-9049';
    if (value < 9550) return '9050-9549';
    return '>=9550';
  }

  if (questionId === 'crefoIndex' && typeof value === 'number') {
    if (value < 150) return '100-149';
    if (value < 200) return '150-199';
    if (value < 250) return '200-249';
    if (value < 300) return '250-299';
    if (value < 350) return '300-349';
    if (value < 500) return '350-499';
    return '500-600';
  }

  return String(value);
};
